import { useState, useEffect } from "react";
import { API_URL } from "../../../helpers";

const Div = ({ status, text }) => {
  let classes = "";
  if (status === 0) {
    classes = "fa fa-times fa-lg error";
  } else if (status === 1) {
    classes = "fa fa-check fa-lg success";
  } else if (status === 2) {
    classes = "fa fa-circle-o-notch fa-spin fa-lg working";
  }

  return (
    <div>
      <div className="i-container">
        <i className={classes} />
      </div>
      <span className={status === 3 ? "working" : ""}>{text}</span>
    </div>
  );
};

const Uploaded = ({ records, type, token, msg }) => {
  const [status, setStatus] = useState({
    1: 1,
    2: 3,
    3: 3,
    4: 3,
    5: 3,
  });

  /* Status
    0 - Error
    1 - Success
    2 - Working
    3 - Idle
  */

  /*
    Step 1 - Uploaded .csv, check column headings are correct
    Step 2 - Checking request ID fields
    Step 3 - Checking request is still approved
    Step 4 - Checking confirmation not empty    
    Step 5 - Parsing data to request records
  */

  useEffect(() => {
    const init = async () => {
      handleBatch(2);
    };

    init();

    // eslint-disable-next-line
  }, []);

  const handleBatch = async (num) => {
    setStatus((status) => ({ ...status, [num]: 2 }));

    const url = new URL(`${API_URL}/admin/hotelUploadBatch${num}`);
    let data = new FormData();
    data.append("type", type);
    data.append("token", token);

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        if (num === 5) {
          setStatus((status) => ({ ...status, [num]: 1 }));
          msg({
            type: "success",
            text: json.text,
          });
        } else {
          const nextNum = num + 1;
          setStatus((status) => ({ ...status, [num]: 1 }));
          handleBatch(nextNum);
        }
      } else {
        setStatus((status) => ({ ...status, [num]: 0 }));
        msg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setStatus((status) => ({ ...status, [num]: 0 }));
      msg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <div className="uploaded-container">
      <Div
        status={status["1"]}
        text={`1 - File uploaded (${records} records)`}
      />
      <Div status={status["2"]} text="2 - Checking request ID fields" />
      <Div status={status["3"]} text="3 - Checking request status approved" />
      <Div
        status={status["4"]}
        text={
          type === "jw"
            ? "4 - Checking confirmation # fields"
            : "4 - Checking confirmation # field"
        }
      />
      <Div status={status["5"]} text="5 - Processing records in batch" />
    </div>
  );
};

export default Uploaded;
